<ng-container *ngIf="complementaryProducts$ | async as complementaryProducts">
  <section class="may-also-need-section" *ngIf="complementaryProducts?.length">
    <div class="title-section" data-cy="you-may-also-need-text">
      {{ 'i18n.productDetail.recommendations.youMayAlsoNeed' | translate }}
    </div>

    <div id="swiper-slider">
      <div class="yman-swiper-prev arrow-slider">
        <ion-icon
          slot="icon-only"
          name="arrow-back-circle-outline"
          data-cy="swiper-back-icon"
        >
        </ion-icon>
      </div>
      <swiper-container
        slides-per-view="auto"
        navigation-prev-el=".yman-swiper-prev"
        navigation-next-el=".yman-swiper-next"
        observer="true"
        observe-parents="true"
        resize-observer="true"
        (init)="
          setSwiperInstance($event.detail[0], MERCH_FEATURE.youMayAlsoNeedName)
        "
      >
        <swiper-slide
          *ngFor="
            let complementaryProduct of complementaryProducts
              | slice: startSlice : endSlice;
            let index = index
          "
        >
          <app-product-detail-cab-card
            attr.divisionApn="{{
              complementaryProduct?.summary?.divisionNumber
            }}-{{ complementaryProduct?.productNumber }}"
            attr.attributes="{{ complementaryProduct?.trackingAttributes }}"
            [product]="complementaryProduct"
            [lnkSrc]="lnkSrc.ymanLnkSrc"
            [merchRank]="index + 1"
            [showPromotionDetailInTablet]="true"
            (quantityUpdateEmitter)="
              onQuantityUpdate(
                $event,
                MERCH_FEATURE.youMayAlsoNeedName,
                index + 1
              )
            "
            (productImageClickEmitter)="
              onProductImageClick(complementaryProduct, index + 1)
            "
            [isGuestUser]="isGuestUser"
          >
          </app-product-detail-cab-card>
        </swiper-slide>
      </swiper-container>
      <div class="yman-swiper-next arrow-slider">
        <ion-icon
          slot="icon-only"
          name="arrow-forward-circle-outline"
          data-cy="forward-swiper-icon"
        ></ion-icon>
      </div>
    </div>
  </section>
</ng-container>
<ng-container *ngIf="productRecommendations$ | async as productRecs">
  <section
    class="cust-also-bought-section"
    *ngIf="productRecs?.products?.length > 0"
  >
    <div class="title-section" data-cy="customer-also-bought-text">
      {{ 'i18n.productDetail.recommendations.customersAlsoBought' | translate }}
    </div>

    <div id="swiper-slider">
      <div class="cab-swiper-prev arrow-slider">
        <ion-icon
          slot="icon-only"
          name="arrow-back-circle-outline"
          data-cy="swiper-back-icon"
        >
        </ion-icon>
      </div>
      <swiper-container
        slides-per-view="auto"
        navigation-prev-el=".cab-swiper-prev"
        navigation-next-el=".cab-swiper-next"
        observer="true"
        observe-parents="true"
        resize-observer="true"
        (init)="
          setSwiperInstance(
            $event.detail[0],
            MERCH_FEATURE.customerAlsoBoughtName
          )
        "
      >
        <swiper-slide
          *ngFor="
            let productRecommendation of productRecs?.products
              | slice: startSlice : endSlice;
            let index = index
          "
        >
          <app-product-detail-cab-card
            attr.divisionApn="{{
              productRecommendation?.summary?.divisionNumber
            }}-{{ productRecommendation?.productNumber }}"
            attr.attributes="{{ productRecommendation?.trackingAttributes }}"
            [product]="productRecommendation"
            [lnkSrc]="lnkSrc.cabLnkSrc"
            [merchRank]="index + 1"
            [variant]="productRecs?.variant"
            [showPromotionDetailInTablet]="true"
            (quantityUpdateEmitter)="
              onQuantityUpdate(
                $event,
                MERCH_FEATURE.customerAlsoBoughtName,
                index + 1,
                productRecs?.variant
              )
            "
            (productImageClickEmitter)="
              onProductImageClick(productRecommendation, index + 1)
            "
            [isGuestUser]="isGuestUser"
          >
          </app-product-detail-cab-card>
        </swiper-slide>
      </swiper-container>
      <div class="cab-swiper-next arrow-slider">
        <ion-icon
          slot="icon-only"
          name="arrow-forward-circle-outline"
          data-cy="forward-swiper-icon"
        ></ion-icon>
      </div>
    </div>
  </section>
</ng-container>
